import { apiAuth, apiResponseType } from ".";

export const getDiscountTypesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`discount-types?page=${page}`);

export const registerDiscountTypesData = (data) =>
  apiAuth.postForm("/discount-types/store", data) as apiResponseType;
export const deleteDiscountTypesData = (uuid: string) =>
  apiAuth.delete(`discount-types/${uuid}/destroy`) as apiResponseType;
export const updateDiscountTypesData = (uuid: string, data) =>
  apiAuth.put(`discount-types/${uuid}/update`, data) as apiResponseType;

export const getShowDiscountTypes = (uuid: string) =>
  apiAuth.get(`discount-types/${uuid}/show`) as apiResponseType;

export const searchDiscountTypesData = (params: {
  name: string;
}): apiResponseType => apiAuth.get(`discount-types?name=${params.name}`);

export const setStatusDiscountTypes = (uuid: string) =>
  apiAuth.put(`discount-types/${uuid}/toggle-status`) as apiResponseType;

export const getSelectDiscountTypes = () =>
  apiAuth.get(`discount-types/select`) as apiResponseType;
